import { render } from "./VideoThumb.vue?vue&type=template&id=3d5c0672&scoped=true"
import script from "./VideoThumb.vue?vue&type=script&lang=ts"
export * from "./VideoThumb.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3d5c0672"

export default script